import { AbstractPolyShapeHelper } from '../abstract-polyshape-helper';

export class LineHelper extends AbstractPolyShapeHelper {
  protected lineWidth = 3;

  constructor(index: number) {
    super(index, 'lines');
  }

  getPolyShapeType() {
    return 'polyline';
  }

  getPolyShapeName() {
    return `polyline-${this.index}`;
  }
}
